import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link, useHistory, useParams } from "react-router-dom";
import useSocket from "use-socket.io-client";
import {
  useAppGuestUserIdSelector,
  useAppUserDetailsSelector,
  useAppUserTokenSelector,
} from "src/_common/hooks/selectors/userSelector";
import {
  useAppEventStatusMessageSelector,
  useAppGameDetailsSelector,
  useAppIrStatusMessageSelector,
  useAppSiteHeaderSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  URLS,
  STORAGE,
  SELECTED_EVENT_STORAGE,
  INSIDERODEO_EVENT_STORAGE,
  detectDevice,
  IS_SHOWING_ADD_TO_HOME_SCREEN_IOS,
  CRYPTO_SECRET_KEY,
  APPLICATION_GLOBAL_SLUG,
  APPLICATION_VERSION,
} from "src/_config";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { SOCKET_CHANNEL, SOCKET_URL, RODEO_PAGE_NAME } from "src/_config";
import GuestSaveVoteModal from "../events/modal/guestSaveVoteModal";
import StatusModal from "../events/modal/statusModal";
import CouponModal from "../events/modal/couponModal";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import UpdateDisplayNameModal from "../events/modal/updateDisplayNameModal";
import VideoModal from "../events/modal/videoModal";
interface SideBarProps {
  page: string;
}

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

function Sidebar({ page }: SideBarProps) {
  const siteHeader = useAppSiteHeaderSelector();
  const history = useHistory();
  const userDetails = useAppUserDetailsSelector();
  const statusMessageSelector = useAppEventStatusMessageSelector();
  const irStatusMessageSelector = useAppIrStatusMessageSelector();
  const userAction = useAppUserAction();
  const eventAction = useAppEventAction();
  const userApi = useUserApi();
  const toast = useToaster();
  // const guestUserId = useAppGuestUserIdSelector()
  const [showGuestSaveVoteModal, setShowGuestSaveVoteModal] = useState<boolean>(false);

  const { eventId } = useParams<any>();
  // const e_id: number = parseInt(cryptr.decrypt(eventId));

  const isInsideRodeoTokenExists = localStorage.getItem(INSIDERODEO_EVENT_STORAGE);
  const [isShowIosPopup, setIsShowIosPopup] = useState<any>(
    localStorage.getItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS)
      ? parseInt(localStorage.getItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS) || "0")
      : 1
  );
  const [appRedirectData, setAppRedirectData] = useState<any>();
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const [showCouponModal, setShowCouponModal] = useState<boolean>(false);
  const [couponData, setCouponData] = useState<any>();
  const userToken = useAppUserTokenSelector();
  const autoLogin = localStorage.getItem("autoLogin");

  // const [showHeaderMenu, setShowHeaderMenu] = useState<boolean>(true)
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const eventApi = useEventApi();
  const gameDetails = useAppGameDetailsSelector();
  const [showDisplayNameModal, setShowDisplayNameModal] = useState<boolean>(false);
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [url, setUrl] = useState<any>("");
  const [promoType, setPromoType] = useState<any>("");

  const getGameDetails = () => {
    let params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (message: any, resp: any) => {
        console.log({ resp });
        getStatusMessage(resp.id);
        if (resp?.is_show_landing_page) {
          history.push(URLS.HOME);
        }
      },
      (message: any) => {}
    );
  };

  const getStatusMessage = (id: any) => {
    let params = {
      game_id: id,
    };
    eventApi.callGetGameStatusText(
      params,
      (message: any, resp: any) => {},
      (message: any) => {}
    );
  };

  const toogleSideBarOnOff = (status: boolean) => {
    var sidebarCollapseElement = document.getElementById("sidebarCollapse");
    var sidebarElement = document.getElementById("sidebar");
    var overlayElement = document.getElementById("overlay");
    if (status) {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.add("active");
        overlayElement?.classList.add("active");
      }
    } else {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.remove("active");
        overlayElement?.classList.remove("active");
      }
    }
  };

  // const toogleProfileMenuBarOnOff = () => {
  //   var navbarCollapseElement = document.getElementById("navbarCollapse");
  //   setShowHeaderMenu(!showHeaderMenu)
  //   if (showHeaderMenu) {
  //     if (navbarCollapseElement) {
  //       navbarCollapseElement.classList.add("show")
  //     }
  //   } else {
  //     if (navbarCollapseElement) {
  //       navbarCollapseElement.classList.remove("show")
  //     }
  //   }
  // }

  const logOut = (e: React.MouseEvent) => {
    userApi.callLogout(
      (message: string, resp: any) => {
        // if (resp) {
        toogleSideBarOnOff(false);
        userAction.logout();
        localStorage.removeItem(STORAGE);
        localStorage.removeItem(SELECTED_EVENT_STORAGE);
        localStorage.removeItem(INSIDERODEO_EVENT_STORAGE);
        history.push(URLS.HOME);
        // } else {
        //   toast.error(message)
        // }
      },
      (message: string) => {
        userAction.logout();
        // toast.error(message)
      }
    );
  };

  const goToMyAccount = () => {
    history.push(URLS.USER.PROFILE);
  };

  const closeIosPopup = (e: any) => {
    e.preventDefault();
    setIsShowIosPopup(0);
    localStorage.setItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS, "0");
  };

  const closeGuestSaveVoteModal = () => {
    if (showGuestSaveVoteModal) setShowGuestSaveVoteModal(false);

    eventAction.resetPickIds();
    userAction.resetGuestUserId();
    localStorage.removeItem("guestUserId");
    history.push(URLS.HOME);
  };

  const onSuccessGuestSaveVoteModal = (status: boolean) => {
    if (status) {
      // console.log("APIcall")
      // saveVote()
      history.push(URLS.LOGIN);
    }
  };

  const onStatusModalClose = () => {
    setShowStatusModal(false);
  };

  const onCouponModalClose = () => {
    setShowCouponModal(false);
  };

  const closeVideoModal = () => {
    localStorage.setItem("loginPromoVidSeen", "1");
    setTimeout(() => setShowVideoModal(false), 1000);
  };

  const onStatusModalSuccess = () => {
    if (appRedirectData) {
      setShowStatusModal(false);
      let link = appRedirectData.game_info.pwa_link;
      if (link) {
        // if (userDetails && userToken) {

        window.location.href =
          link +
          (appRedirectData?.rodeo_event_id
            ? `#token=${cryptr.encrypt(appRedirectData.rodeo_event_id)}&userToken=${userToken}`
            : "");
        // }
      }
    }
  };

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
  });

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      let e_id = -1;
      if (eventId) {
        e_id = parseInt(cryptr.decrypt(eventId));
      }
      let guestUserId = localStorage.getItem("guestUserId");
      // console.log({e_id,changeEventStatus,guestUserId})
      if (
        changeEventStatus &&
        changeEventStatus.status == 2 &&
        changeEventStatus.rodeo_event_id == e_id &&
        guestUserId
      ) {
        // console.log(changeEventStatus)
        setShowGuestSaveVoteModal(true);
      }
    });

    socket.on(SOCKET_CHANNEL.APP_REDIRECT, (data: any) => {
      if (data.game_info.slug != APPLICATION_GLOBAL_SLUG) {
        // console.log({data})
        setShowStatusModal(true);
        setAppRedirectData(data);
      }
    });

    socket.on(SOCKET_CHANNEL.COUPON, (data: any) => {
      // console.log({data})
      setCouponData(data);
      setShowCouponModal(true);
    });

    socket.on(SOCKET_CHANNEL.IR_STATUS_MSG, (changeEventStatus: any) => {
      console.log("irStatus", changeEventStatus);
      if (changeEventStatus?.site == APPLICATION_GLOBAL_SLUG) {
        eventAction.getIrStatusMessage(changeEventStatus);
      }
    });

    //Status Message Change Socket
    socket.on(SOCKET_CHANNEL.STATUS_MESSAGE, (statusMessage: any) => {
      // console.log({statusMessage})
      if (eventId) {
        let e_id = parseInt(cryptr.decrypt(eventId));
        if (statusMessage.rodeo_event_id == e_id) {
          eventAction.setStatusMsg([statusMessage]);
        }
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    // console.log({siteHeader,page})
    let elem: any = document.getElementsByClassName("main-container")[0];
    if (elem) {
      if (page == RODEO_PAGE_NAME.GROUP_LEADERBOARD) {
        elem.style.paddingTop = "80px";
      } else if (siteHeader != 1 || page == RODEO_PAGE_NAME.EVENT_LIST || page == RODEO_PAGE_NAME.EVENT_GROUP) {
        elem.style.paddingTop = "15px";
      } else {
        elem.style.paddingTop = "80px";
      }
    }
    let parshedHash = localStorage.getItem("parshedHash");
    if (parshedHash == "1") {
      userApi.callCreateUpdateUserGame(
        {
          game_slug: APPLICATION_GLOBAL_SLUG,
        },
        (message: string, resp: any) => {
          console.log({ resp });
          localStorage.removeItem("parshedHash");
        },
        (message: string) => {}
      );
    }
  }, [siteHeader, page]);

  useEffect(() => {
    getGameDetails();
  }, []);

  const onPageChange = () => {
    if (userDetails && !userDetails.display_name) {
      // console.log({userDetails})
      setShowDisplayNameModal(true);
    }
  };

  useEffect(() => {
    onPageChange();
  }, []);

  useEffect(() => {
    console.log({ page });
  }, [page]);

  useEffect(() => {
    if (userToken) {
      userApi.callCheckValidToken(
        (message: any, resp: any) => {
          // console.log(1,{resp})
          if (!resp) {
            // console.log(2,{resp})
            userAction.logout();
          }
        },
        (message: any, resp: any) => {
          // console.log(3,{resp})
          userAction.logout();
        }
      );
    }
  }, [page]);

  useEffect(() => {
    let x = localStorage.getItem("loginPromoVidSeen");
    if (page == RODEO_PAGE_NAME.LOGIN && gameDetails?.promotional_video_image && x != "1") {
      let vid = gameDetails?.promotional_video_image;
      let type = vid?.file_mime.substring(0, vid?.file_mime?.indexOf("/"));
      setPromoType(type);
      setUrl(vid?.original);
      if (type == "video" || type == "image") {
        setShowVideoModal(true);
      }
    }
  }, [page, gameDetails]);

  const gotoHome = () => {
    history.push(URLS.HOME);
  };

  // const refreshCacheAndReload = () => {
  //   if (caches) {
  //     // Service worker cache should be cleared with caches.delete()
  //     caches.keys().then((names) => {
  //       for (const name of names) {
  //         caches.delete(name);
  //       }
  //     });
  //   }
  //   // delete browser cache and hard reload
  //   window.location.reload();
  // }

  // useEffect(()=>{
  //   let ver = localStorage.getItem('buildVersion')
  //   if(ver) {
  //     if(ver!=APPLICATION_VERSION) {
  //       localStorage.setItem('buildVersion',APPLICATION_VERSION)
  //       refreshCacheAndReload()
  //     }
  //   } else {
  //     localStorage.setItem('buildVersion',APPLICATION_VERSION)
  //   }
  // },[])

  useEffect(() => {
    localStorage.removeItem("autoLogin");
  }, []);

  return (
    <>
      {url && showVideoModal && promoType && (
        <VideoModal onClose={closeVideoModal} url={url} shouldShow={showVideoModal} type={promoType} />
      )}
      {/* <section className={"top-nav "+([RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && siteHeader==1?"":"d-none")}> */}
      <section
        className={
          "top-nav " +
          (((page == RODEO_PAGE_NAME.CMS ||
            page == RODEO_PAGE_NAME.MY_ACCOUNT ||
            page == RODEO_PAGE_NAME.TEAM_IMAGE ||
            eventId) &&
            siteHeader == 1) ||
          page == RODEO_PAGE_NAME.MY_TEAM ||
          page == RODEO_PAGE_NAME.GROUP_LEADERBOARD ||
          ((page == RODEO_PAGE_NAME.EVENT_LIST ||
            page == RODEO_PAGE_NAME.EVENT_GROUP ||
            page == RODEO_PAGE_NAME.LANDING) &&
            irStatusMessageSelector)
            ? ""
            : "d-none")
        }
      >
        {/*LEFT MENU*/}
        {/*Navbar*/}
        <nav
          id="sidebar"
          className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
          style={{ overflow: "visible" }}
        >
          <div id="dismiss" onClick={() => toogleSideBarOnOff(false)}>
            <i className="fa fa-arrow-left" />
          </div>
          <div className="sidebar-header">
            {gameDetails?.logo?.original && (
              <img src={gameDetails?.logo?.original} alt="Rodeo Picks" onClick={gotoHome} />
            )}{" "}
            Rodeo Picks
          </div>
          {userDetails && (
            <div className="head-user">
              {/* Welcome, {userDetails && userDetails.full_name && userDetails.full_name !== " " ? userDetails.full_name : ' User'} */}
              Welcome,{" "}
              {userDetails && userDetails.first_name && userDetails.last_name
                ? userDetails.first_name + " " + userDetails.last_name
                : " User"}
            </div>
          )}

          {/* <ul className="list-unstyled components">
            {
              !isInsideRodeoTokenExists ?
                <li>
                  <Link to={URLS.HOME}>Rodeo Events</Link>
                </li> : null
            }
            {
              userDetails ?
              <li>
                <Link to={URLS.USER.PROFILE}>My Profile</Link>
              </li>
              :
              <li>
                <Link to={URLS.LOGIN}>Login</Link>
              </li>
            }

            <li>
              <Link to={URLS.CMS.ABOUT_US}>About Us</Link>
            </li>
            <li>
              <Link to={URLS.CMS.LEGAL}>Legal</Link>
            </li>
            {
              userDetails && !autoLogin &&
              <li>
                <Link to="#" onClick={(e) => logOut(e)}>Logout</Link>
              </li>
            }

          </ul> */}
        </nav>
        <nav className="navbar navbar-light">
          <div className="container-fluid">
            {/* <button type="button" id="sidebarCollapse" className="btn-none">
              <span className="open-nav" onClick={() => toogleSideBarOnOff(true)}><i className="fa fa-bars"></i></span>
            </button> */}
            <div className="left-logo">
              {gameDetails?.logo?.original && (
                <img src={gameDetails?.logo?.original} alt="Rodeo Picks" onClick={gotoHome} />
              )}
            </div>
            {
              // [RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && statusMessageSelector && statusMessageSelector[0]?.status_text ?
              statusMessageSelector && statusMessageSelector[0]?.status_text && eventId ? (
                <div className="status-bar-wrap">
                  <Marquee direction="left" loop={0} pauseOnHover={true} speed={60}>
                    {
                      // statusMessageSelector && statusMessageSelector.length ?
                      // statusMessageSelector.map((status: any) => status.status_text).join(',')
                      statusMessageSelector[0]?.status_text
                    }
                  </Marquee>
                </div>
              ) : irStatusMessageSelector ? (
                <div className="status-bar-wrap">
                  <Marquee direction="left" loop={0} pauseOnHover={true} speed={60}>
                    {irStatusMessageSelector}
                  </Marquee>
                </div>
              ) : null
            }
            {/* {
              userDetails &&
              <button
                className="navbar-toggler btn-none d-inline-block ml-auto user-image"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
                // onClick={toogleProfileMenuBarOnOff}
                onClick={goToMyAccount}
              >
                <img src="/images/user.svg" alt="User" />
              </button>
            } */}
          </div>
        </nav>
        <div className="overlay" id="overlay" onClick={() => toogleSideBarOnOff(false)} />

        {/* IOS Scrren Add to home scrren option popup */}
        {/* {
          detectDevice() && isShowIosPopup ?
            <>
              < div className="bottom_fixedsec">
                <div className="mid-sec">
                  <h2>To add this Instant app to the home screen: tap <span className="share-x-icon" /> and then Add to Home Screen.</h2>
                </div>
                <div className="icon_div_right">
                  <a href="#" onClick={(e) => closeIosPopup(e)}>
                    <svg className="svg-inline--fa fa-times-circle fa-w-16" aria-hidden="true" data-prefix="fa" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg>
                      <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
                    </svg>
                  </a>
                </div>
              </div>
            </> : null
        } */}
      </section>

      {!autoLogin && (
        <>
          {/* <div className={"floating-btns "+(showMenu ? "floating-btns-show" : "")}> */}
          {/* <div className={"floating-btns "+([RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && siteHeader==1?"":"d-none ")+(showMenu ? "floating-btns-show" : "")}> */}
          <div
            className={
              "floating-btns " +
              (page == RODEO_PAGE_NAME.EVENT_LIST ||
              page == RODEO_PAGE_NAME.GROUP_LEADERBOARD ||
              (eventId && siteHeader == 1)
                ? ""
                : "d-none ") +
              (showMenu ? "floating-btns-show" : "")
            }
          >
            {/* {!isInsideRodeoTokenExists ? <Link to={URLS.HOME}>Rodeo Events</Link> : null} */}

            <Link to={URLS.EVENT.GROUPS}>Rodeo Events</Link>
            <Link to={URLS.EVENT.PAST_RODEO_LIST}>Past Rodeo Events</Link>

            {userDetails ? <Link to={URLS.USER.PROFILE}>My Profile</Link> : <Link to={URLS.LOGIN}>Login</Link>}

            {userDetails && eventId ? <Link to={`/winning-ticket/${eventId}`}>My Correct Picks</Link> : null}

            {userDetails && eventId ? <Link to={`/my-team/${eventId}`}>My Team</Link> : null}

            <Link to={"/cms/prize-winner"}>Prize</Link>

            <Link to={"/cms/about-us"}>About Us</Link>

            <Link to={"/cms/contact-us"}>Contact Us</Link>

            {userDetails && !autoLogin && (
              <a style={{ color: "white", cursor: "pointer" }} onClick={(e) => logOut(e)}>
                Logout
              </a>
            )}

            <Link to={"/cms/legal"}>Legal</Link>

            <Link to={"/cms/schedule"}>Schedule</Link>
          </div>

          {/* <div className={"float-bar-icon "+([RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && siteHeader==1?"":"d-none")} onClick={()=>setShowMenu(!showMenu)}> */}
          <div
            className={
              "float-bar-icon " +
              (page == RODEO_PAGE_NAME.EVENT_LIST ||
              page == RODEO_PAGE_NAME.GROUP_LEADERBOARD ||
              (eventId && siteHeader == 1)
                ? ""
                : "d-none")
            }
            onClick={() => setShowMenu(!showMenu)}
          >
            <i className="fa fa-list" aria-hidden="true" />
          </div>
        </>
      )}

      {showGuestSaveVoteModal && (
        <GuestSaveVoteModal
          onClose={closeGuestSaveVoteModal}
          onSuccess={onSuccessGuestSaveVoteModal}
          shouldShow={showGuestSaveVoteModal}
        />
      )}
      {showStatusModal && appRedirectData && (
        <StatusModal
          shouldShow={showStatusModal}
          onClose={onStatusModalClose}
          onSuccess={onStatusModalSuccess}
          message={appRedirectData?.message}
          type={2}
        />
      )}
      {showDisplayNameModal && (
        <UpdateDisplayNameModal onClose={() => setShowDisplayNameModal(false)} shouldShow={showDisplayNameModal} />
      )}
      {showCouponModal &&
        couponData &&
        couponData.image &&
        (couponData.type == 1 || (couponData.type == 2 && userDetails && userDetails.id)) && (
          <CouponModal shouldShow={showCouponModal} onClose={onCouponModalClose} image={couponData.image} />
        )}
    </>
  );
}

export default Sidebar;
